module.exports = __webpack_public_path__ + "static/media/initialposter.5e2e8a1e.webp";